/**
 * Planner-wide display for event times (calendar chips, picker label, hover, lists).
 */

export const PLANNER_TIME_FORMAT_24 = '24h';
export const PLANNER_TIME_FORMAT_12 = '12h';

export const STORAGE_KEY_PLANNER_TIME_FORMAT = 'planner_time_display_format';

/** @returns {'24h' | '12h'} */
export function loadPlannerTimeFormatFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PLANNER_TIME_FORMAT);
    if (raw === PLANNER_TIME_FORMAT_12) return PLANNER_TIME_FORMAT_12;
    return PLANNER_TIME_FORMAT_24;
  } catch {
    return PLANNER_TIME_FORMAT_24;
  }
}

/** @param {'24h' | '12h'} mode */
export function persistPlannerTimeFormat(mode) {
  if (mode !== PLANNER_TIME_FORMAT_12 && mode !== PLANNER_TIME_FORMAT_24) return;
  try {
    localStorage.setItem(STORAGE_KEY_PLANNER_TIME_FORMAT, mode);
  } catch {
    /* ignore */
  }
}

/** @param {'24h' | '12h' | unknown} mode */
export function plannerTimeUses24Hour(mode) {
  return mode !== PLANNER_TIME_FORMAT_12;
}

/**
 * Time-of-day fragment for timed events (no date).
 * @param {string | null | undefined} isoDatetime
 * @param {'24h' | '12h'} formatMode
 */
export function formatPlannerEventHm(isoDatetime, formatMode) {
  if (!isoDatetime) return '';
  const date = new Date(isoDatetime);
  if (Number.isNaN(date.getTime())) return '';
  const hour12 = formatMode === PLANNER_TIME_FORMAT_12;
  try {
    return date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12,
    });
  } catch {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12,
    });
  }
}
